import React from "react"

import CTABannerSectionDesktop from "./CTABannerSectionDesktop"
import CTABannerSectionMobile from "./CTABannerSectionMobile"

const CTABannerSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <CTABannerSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <CTABannerSectionDesktop
        section={section}
        practice={practice}
        theme={theme}
        highlightedField={highlightedField}
      />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <CTABannerSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return (
    <CTABannerSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default CTABannerSection
